import React, { useContext } from "react";
import { EntitiesContext } from "../../../App";
import logo from "../../../images/wespta-ski-logo-min.png";
import plymouth from "../../../images/plymouth.png";
import rodgers from "../../../images/rodgers.png";
import pinnacle from "../../../images/pinnacle.png";
import north from "../../../images/north.png";
import ajs from "../../../images/ajs.png";
import power from "../../../images/power.png";
import mountain from "../../../images/logo.webp";
import ikea from "../../../images/ikea.jpg";
import alpineoptions from "../../../images/alpineoptions.png";
import eurohat from "../../../images/eurohat.png";
import ussherpa from "../../../images/ussherpa.png";
import mountainside from "../../../images/mountainside.png";
import stockli from "../../../images/stockli.png";
import himal from "../../../images/himal.png";
import mountainer from "../../../images/mountainer.png";
import neon from "../../../images/neon.svg";
import umiak from "../../../images/UMIAK_2.png";
import snovix from "../../../images/snovix.jpg";

export default function Vendors({ setSearch, setVendorId }) {
	const entities = useContext(EntitiesContext);
	const vendors = entities.state.get("account").filter((a) => a.isVendor);

	// the Custom component in Order is setup to look for the
	// vendor identifer inventory item and then get the vendor from that
	// this was based on the original implementation where the
	// vendor identifier was provided by scanning a QR code
	const findVendorInventory = (id) => {
		setVendorId(id);
		setSearch(null);
	};

	const setImage = (name) => {
		switch (name.toLowerCase()) {
			case "plymouth ski & sport":
				return <img src={plymouth} width="25%" />;
			case "pinnacle sports":
				return <img src={pinnacle} width="25%" />;
			case "waitsfield pta donations":
				return <img src={logo} width="25%" />;
			case "vermont north":
				return <img src={north} width="25%" />;
			case "ajs ski and sport":
				return <img src={ajs} width="25%" />;
			case "power play sports":
				return <img src={power} width="25%" />;
			case "mountain ops":
				return <img src={mountain} width="25%" />;
			case "ikea bag":
				return <img src={ikea} width="25%" />;
			case "alpine options":
				return <img src={alpineoptions} width="25%" />;
			case "euro hat":
				return <img src={eurohat} width="25%" />;
			case "us sherpa":
				return <img src={ussherpa} width="25%" />;
			case "mountainside ski service":
				return <img src={mountainside} width="25%" />;
			case "stockli":
				return <img src={stockli} width="55%" />;
			case "himal":
				return <img src={himal} width="85%" />;
			case "middlebury mountaineer":
				return <img src={mountainer} width="75%" />;
			case "neon wave":
				return <img src={neon} width="100%" />;
			case "umiak":
				return <img src={umiak} width="50%" />;
			case "snovix":
				return <img src={snovix} width="45%" />;
		}
	};

	return (
		<div className="vendors-container">
			{vendors.valueSeq().map((v) => (
				<div
					className="vendor-item"
					key={v.id}
					onClick={() => findVendorInventory(v.id)}
				>
					<figure>
						{setImage(v.vendor_name)}
						<figcaption>{v.vendor_name}</figcaption>
					</figure>
				</div>
			))}
		</div>
	);
}
